import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import { sectionsProductListConfig } from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import MountingRailInfoMessage from 'rangeConfig/boaxel/widgets/MountingRailInfoMessage';
import ChangeColorOnScene from 'rangeConfig/boaxel/widgets/ChangeColorOnScene.js';
import checkWidget from 'rangeConfig/shared/widgets/checkWidget';
import ChangeHeightFilter from 'rangeConfig/boaxel/widgets/ChangeHeightFilter';

const widgets = {
  desktop: [
    {
      id: 'change-sections-color',
      component: ChangeColorOnScene
    },
    {
      id: 'change-section-height',
      component: ChangeHeightFilter
    },
    {
      id: 'section-list',
      component: withProducts(ProductList, sectionsProductListConfig)
    },
    {
      id: 'mounting-rail-info-message',
      component: MountingRailInfoMessage
    }
  ],
  mobile: [
    {
      id: 'change-sections-color',
      component: ChangeColorOnScene,
      title: 'storageone.productDetailsAppearanceTitle'
    },
    {
      id: 'change-section-height',
      component: checkWidget(ChangeHeightFilter),
      title: 'storageone.height'
    },
    {
      id: 'sections-product-list',
      component: withProducts(ProductSwiper, sectionsProductListConfig),
      title: 'storageone.selectedProductListAddSections'
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListSectionsCategoryTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  widgets: widgets[platform]
};

export default mainMenu;
